import React, {Fragment, PureComponent} from 'react';
import {Button} from 'react-bootstrap';
import autobind from 'autobind-decorator';

import {GenericModelViewer} from "../../GenericModelViewer";

import {SurveyFormInputEnhance} from "./SurveyFormInputEnhance";

@SurveyFormInputEnhance
export class SurveyFormInputGenericModelViewer extends PureComponent {
    @autobind
    updateValidation(validation, editorGuid) {
        const { SurveyFormInput } = this.props;
        let valid = true;

        Object.keys(validation).forEach((x) => {
            const result = validation[x];

            if(result) {
                valid &= result.valid;
            }
        });

        if(valid) {
            SurveyFormInput.MarkValidationStatusValid();
        } else {
            SurveyFormInput.SetValidationStatusError("This section must be completed.");
        }
    }

    @autobind
    updateModel(data) {
        const { AnswerFieldSetter, SurveyFormInput } = this.props;

        SurveyFormInput.Change((answer) => {
            AnswerFieldSetter(answer, data);

            return answer;
        });
    }

    @autobind
    onAdd() {
        const { NewModel } = this.props

        this.updateModel(NewModel);
    }

    @autobind
    onDelete() {
        this.updateModel(null);
    }

    render() {
        const { AnswerFieldGetter, SurveyFormInput, Model, EditMode, IsNewModel } = this.props
        const data = AnswerFieldGetter(SurveyFormInput.GetAnswer());

        return <Fragment>
            {
                EditMode ?
                    <div className="float-right bottom10">
                        {
                            data ?
                                <Button
                                    variant="delete"
                                    onClick={this.onDelete}
                                >
                                    Delete
                                </Button>:
                                <Button
                                    variant="save"
                                    onClick={this.onAdd}
                                >
                                    Add
                                </Button>
                        }
                    </div>:
                    null
            }
            {
                data ?
                    <GenericModelViewer
                        Model={Model}
                        IsNewModel={IsNewModel(data)}
                        EditMode={EditMode}
                        Data={data}
                        Update={this.updateModel}
                        OnValidationUpdate={this.updateValidation}
                    />:
                    null
            }
        </Fragment>;
    }
}


